import { useNavigate } from 'react-router';
import { Button } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { type CSSProperties } from 'react';
import { OutlinePlusIcon } from '@tempmee/react-icons';

interface ICreatePostingButtonProps {
  text?: string;
  variant?: 'default' | 'lite';
  /** DS Button color for the default variant. Use `inverse` for the white pill on a colored card. @default 'primary' */
  color?: 'primary' | 'secondary' | 'error' | 'cta' | 'inverse';
  style?: CSSProperties;
  textStyle?: CSSProperties;
  dataCy?: string;
  onTrack?: (postingId?: string) => void;
}

export const CreatePostingButton: React.FC<ICreatePostingButtonProps> = ({
  text = 'Post job',
  variant = 'default',
  color = 'primary',
  style,
  textStyle,
  dataCy = 'create-perm-job-button',
  onTrack,
}: ICreatePostingButtonProps) => {
  const navigate = useNavigate();

  const handleCreateDraft = () => {
    onTrack?.();
    navigate('/permanent-jobs/value-proposition');
  };

  if (!getShouldEnforcePermanentJobV2()) {
    return null;
  }

  if (variant === 'lite') {
    return (
      <Button
        data-testid="create-permanent-job-button"
        data-cy={dataCy}
        size="small"
        variant="contained"
        color="secondary"
        startIcon={<OutlinePlusIcon color={colors.shades[0]} />}
        style={style}
        onClick={handleCreateDraft}
      >
        {text}
      </Button>
    );
  }

  return (
    <Button
      data-testid="create-permanent-job-button"
      data-cy={dataCy}
      // width 206 has no DS size token; kept as inline style for the dashboard top-button row
      style={{ width: 206, ...style }}
      variant="contained"
      color={color}
      size="medium"
      loading={false}
      onClick={handleCreateDraft}
    >
      <span style={textStyle}>{text}</span>
    </Button>
  );
};
